module.exports = __webpack_public_path__ + "static/media/mobileMenu4.474ed264.jpeg";